import $ from 'jquery';

const events = {
    _triggerEvent: function(data) {
        if (window.dataLayer && window.dataLayer.push) {
            window.dataLayer.push(data);
        }
    },
    _orderControlInteractionLabel: function(category, label) {
        this._gaEvent(category, window.location.href, label);
    },
    _gaEvent: function(category, action, label) {
        if (/\.com/gi.test(action)) {
            action = action.split('?')[0];
        }
        this._triggerEvent({
            event: 'gaTriggerEvent',
            gaEventCategory: category,
            gaEventAction: action,
            gaEventLabel: label
        });
    },
    _getCartData: function() {
        var dfd = new $.Deferred();

        $.get('/api/shoppingcart/GetCartItems').done(function(response) {
            dfd.resolve(response.Status === smartPak.HTTP_STATUS_OK ? response.Content.CartItems : []);
        });

        return dfd.promise();
    },
    _formatCartData: function(cartItems) {
        var SUPPY_TYPE = 2;

        return cartItems
            .reduce(function(items, item) {
                if (item.ProductType === SUPPY_TYPE) {
                    items.push({
                        productId: item.ProductId + '',
                        quantity: item.Quantity,
                        itemPrice: item.DiscountedPrice,
                        itemId: item.ItemId
                    });
                } else {
                    item.SupplementViewModels.forEach(function(supplement) {
                        items.push({
                            productId: supplement.ProductId + '',
                            quantity: supplement.Quantity,
                            itemPrice: supplement.DiscountedPrice,
                            itemId: supplement.ItemId
                        });
                    });
                }

                return items;
            }, [])
            .sort(function(a, b) {
                return a.itemId < b.itemId ? -1 : 1;
            })
            .map(function(item) {
                delete item.itemId;
                return item;
            });
    },
    _dynamicYieldAddToCart: function(data) {
        if (window.DY && window.DY.API) {
            this._getCartData().done(
                function(cartItems) {
                    // eslint-disable-next-line new-cap
                    window.DY.API('event', {
                        name: 'Add to Cart',
                        properties: {
                            dyType: 'add-to-cart-v1',
                            value: data.price,
                            currency: 'USD',
                            productId: data.sku + '',
                            quantity: data.quantity,
                            cart: this._formatCartData(cartItems)
                        }
                    });
                }.bind(this)
            );
        }
    },
    addToCart: function(data) {
        this._triggerEvent({
            event: 'addToCart',
            productClassId: convertToProductClassId(data.id),
            sku: data.sku,
            price: data.price,
            quantity: data.quantity
        });

        this._dynamicYieldAddToCart({
            sku: data.sku,
            price: data.price,
            quantity: data.quantity
        });
    }
};

function convertToProductClassId(id) {
    var NUM_TO_ADD_TO_ID = 10000;
    return id + NUM_TO_ADD_TO_ID;
}

export default events;
